export default "__VITE_ASSET__DTybji62__"